// extracted by mini-css-extract-plugin
var _1 = "_confirmUpdateStatusProjectModal-module__button-container";
var _2 = "_confirmUpdateStatusProjectModal-module__cancel-button";
var _3 = "_confirmUpdateStatusProjectModal-module__confirm-activate";
var _4 = "_confirmUpdateStatusProjectModal-module__confirm-deactivate";
export { _1 as "button-container", _2 as "cancel-button", _3 as "confirm-activate", _4 as "confirm-deactivate" }
